// Dropdown.tsx
"use client";

import { c as _c } from "react/compiler-runtime";
import { Dropdown as HeroDropdown, DropdownItem as HeroDropdownItem, DropdownMenu as HeroDropdownMenu, DropdownSection as HeroDropdownSection, DropdownTrigger as HeroDropdownTrigger } from "@heroui/react";
import type React from "react";
import { cn } from "../../lib/utils";

// Get the original component props types
export type DropdownProps = React.ComponentProps<typeof HeroDropdown> & {
  className?: string;
};
export type DropdownItemProps = React.ComponentProps<typeof HeroDropdownItem> & {
  className?: string;
};
export type DropdownMenuProps = React.ComponentProps<typeof HeroDropdownMenu> & {
  className?: string;
};
export type DropdownTriggerProps = React.ComponentProps<typeof HeroDropdownTrigger> & {
  className?: string;
};
export type DropdownSectionProps = React.ComponentProps<typeof HeroDropdownSection> & {
  className?: string;
};

// Create the wrapper components
const DropdownWrapper = t0 => {
  const $ = _c(14);
  let children;
  let className;
  let classNames;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = classNames;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    classNames = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn(className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== classNames || $[8] !== t1) {
    t2 = {
      base: t1,
      ...classNames
    };
    $[7] = classNames;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== props || $[12] !== t2) {
    t3 = <HeroDropdown {...props} classNames={t2}>{children}</HeroDropdown>;
    $[10] = children;
    $[11] = props;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
const DropdownItemWrapper = t0 => {
  const $ = _c(14);
  let children;
  let className;
  let classNames;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = classNames;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    classNames = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn(className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== classNames || $[8] !== t1) {
    t2 = {
      ...classNames,
      base: t1
    };
    $[7] = classNames;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== props || $[12] !== t2) {
    t3 = <HeroDropdownItem {...props} classNames={t2}>{children}</HeroDropdownItem>;
    $[10] = children;
    $[11] = props;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
const DropdownMenuWrapper = t0 => {
  const $ = _c(21);
  let children;
  let className;
  let classNames;
  let itemClasses;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      itemClasses,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = classNames;
    $[4] = itemClasses;
    $[5] = props;
  } else {
    children = $[1];
    className = $[2];
    classNames = $[3];
    itemClasses = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn(className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== classNames || $[9] !== t1) {
    t2 = {
      base: t1,
      ...classNames
    };
    $[8] = classNames;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const t3 = itemClasses?.selectedIcon;
  let t4;
  if ($[11] !== t3) {
    t4 = cn("text-primary", t3);
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== itemClasses || $[14] !== t4) {
    t5 = {
      ...itemClasses,
      selectedIcon: t4
    };
    $[13] = itemClasses;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== children || $[17] !== props || $[18] !== t2 || $[19] !== t5) {
    t6 = <HeroDropdownMenu {...props} classNames={t2} itemClasses={t5}>{children}</HeroDropdownMenu>;
    $[16] = children;
    $[17] = props;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
const DropdownTriggerWrapper = t0 => {
  const $ = _c(14);
  let children;
  let className;
  let classNames;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = classNames;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    classNames = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn(className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== classNames || $[8] !== t1) {
    t2 = {
      base: t1,
      ...classNames
    };
    $[7] = classNames;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== props || $[12] !== t2) {
    t3 = <HeroDropdownTrigger {...props} classNames={t2}>{children}</HeroDropdownTrigger>;
    $[10] = children;
    $[11] = props;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
const DropdownSectionWrapper = t0 => {
  const $ = _c(14);
  let children;
  let className;
  let classNames;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = classNames;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    classNames = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn(className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== classNames || $[8] !== t1) {
    t2 = {
      base: t1,
      ...classNames
    };
    $[7] = classNames;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== props || $[12] !== t2) {
    t3 = <HeroDropdownSection {...props} classNames={t2}>{children}</HeroDropdownSection>;
    $[10] = children;
    $[11] = props;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};

// Copy all static properties from the original components
Object.setPrototypeOf(DropdownWrapper, HeroDropdown);
Object.setPrototypeOf(DropdownItemWrapper, HeroDropdownItem);
Object.setPrototypeOf(DropdownMenuWrapper, HeroDropdownMenu);
Object.setPrototypeOf(DropdownTriggerWrapper, HeroDropdownTrigger);
Object.setPrototypeOf(DropdownSectionWrapper, HeroDropdownSection);

// Copy static properties that HeroUI's collection system might need
Object.assign(DropdownWrapper, HeroDropdown);
Object.assign(DropdownMenuWrapper, HeroDropdownMenu);
Object.assign(DropdownTriggerWrapper, HeroDropdownTrigger);
Object.assign(DropdownSectionWrapper, HeroDropdownSection);

// Ensure the components have the right displayName and type
DropdownWrapper.displayName = (HeroDropdown as React.ComponentType<unknown>).displayName || "Dropdown";
DropdownItemWrapper.displayName = (HeroDropdownItem as React.ComponentType<unknown>).displayName || "DropdownItem";
DropdownMenuWrapper.displayName = (HeroDropdownMenu as React.ComponentType<unknown>).displayName || "DropdownMenu";
DropdownTriggerWrapper.displayName = (HeroDropdownTrigger as React.ComponentType<unknown>).displayName || "DropdownTrigger";
DropdownSectionWrapper.displayName = (HeroDropdownSection as React.ComponentType<unknown>).displayName || "DropdownSection";

// Copy the $$typeof symbol if it exists (React uses this for component identification)
if ("$$typeof" in HeroDropdown) {
  (DropdownWrapper as unknown as Record<string, unknown>).$$typeof = (HeroDropdown as unknown as Record<string, unknown>).$$typeof;
}
if ("$$typeof" in HeroDropdownItem) {
  (DropdownItemWrapper as unknown as Record<string, unknown>).$$typeof = (HeroDropdownItem as unknown as Record<string, unknown>).$$typeof;
}
if ("$$typeof" in HeroDropdownMenu) {
  (DropdownMenuWrapper as unknown as Record<string, unknown>).$$typeof = (HeroDropdownMenu as unknown as Record<string, unknown>).$$typeof;
}
if ("$$typeof" in HeroDropdownTrigger) {
  (DropdownTriggerWrapper as unknown as Record<string, unknown>).$$typeof = (HeroDropdownTrigger as unknown as Record<string, unknown>).$$typeof;
}
if ("$$typeof" in HeroDropdownSection) {
  (DropdownSectionWrapper as unknown as Record<string, unknown>).$$typeof = (HeroDropdownSection as unknown as Record<string, unknown>).$$typeof;
}

// Export the wrapped components
export const Dropdown = DropdownWrapper;
export const DropdownItem = DropdownItemWrapper;
export const DropdownMenu = DropdownMenuWrapper;
export const DropdownSection = DropdownSectionWrapper;
export const DropdownTrigger = DropdownTriggerWrapper;